import { render, staticRenderFns } from "./tv-table.vue?vue&type=template&id=3c890836&scoped=true&"
import script from "./tv-table.vue?vue&type=script&lang=ts&"
export * from "./tv-table.vue?vue&type=script&lang=ts&"
import style0 from "./tv-table.vue?vue&type=style&index=0&id=3c890836&prod&lang=scss&"
import style1 from "./tv-table.vue?vue&type=style&index=1&id=3c890836&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c890836",
  null
  
)

export default component.exports